import FinanceAdapter from './base';
import {
  deleteRecordWithAuditReason,
  updateRecordWithAuditReason,
} from 'linced-app/utils/auditing';

export default class Transaction extends FinanceAdapter {
  modelNamePlural = 'transactions';
  deleteRecord = deleteRecordWithAuditReason;
  updateRecord = updateRecordWithAuditReason;
}
